export default "__VITE_ASSET__S_dlqL30__"